import { render } from "./Archivio.vue?vue&type=template&id=3789632e"
import script from "./Archivio.vue?vue&type=script&lang=js"
export * from "./Archivio.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__